module.exports = __webpack_public_path__ + "static/media/7-item-e.424a4267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/7-item-e.jpg
// module id = 1210
// module chunks = 33